import * as React from 'react'

/**
 * @description Shield icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Shield } from '@sravni/design-system-icons'
 *
 * <Shield />
 * ```
 */
export const Shield = React.forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>((props, ref) => (
  <svg ref={ref} data-qa="Shield" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M16.667 9.318c0 3.784-2.845 7.323-6.667 8.182-3.823-.86-6.667-4.398-6.667-8.182V6.346c0-.677.41-1.287 1.036-1.543l4.167-1.705a3.864 3.864 0 0 1 2.928 0l4.167 1.705a1.667 1.667 0 0 1 1.036 1.543v2.972Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m12.708 8.438-3.125 3.124-1.875-1.874"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
))
